// src/actions/session_actions.js
import * as APIUtil from '../util/session_api_util';
import { jwtDecode } from 'jwt-decode';

export const RECEIVE_CURRENT_USER   = "RECEIVE_CURRENT_USER";
export const RECEIVE_SESSION_ERRORS = "RECEIVE_SESSION_ERRORS";
export const RECEIVE_USER_LOGOUT    = "RECEIVE_USER_LOGOUT";
export const RECEIVE_USER_SIGN_IN   = "RECEIVE_USER_SIGN_IN";

// Action creators
export const receiveCurrentUser = (currentUser) => ({
  type: RECEIVE_CURRENT_USER,
  currentUser
});

export const receiveUserSignIn = () => ({
  type: RECEIVE_USER_SIGN_IN
});

export const receiveErrors = (errors) => ({
  type: RECEIVE_SESSION_ERRORS,
  errors
});

export const logoutUser = () => ({
  type: RECEIVE_USER_LOGOUT
});

// Thunks
export const signup = (user) => (dispatch) =>
  APIUtil.signup(user)
    .then(() => dispatch(receiveUserSignIn()))
    .catch((err) => dispatch(receiveErrors(err.response?.data || err)));

export const login = (user) => (dispatch) =>
  APIUtil.login(user)
    .then((res) => {
      const { token } = res.data;
      localStorage.setItem('jwtToken', token);
      APIUtil.setAuthToken(token);
      const decoded = jwtDecode(token); // <-- fixed
      dispatch(receiveCurrentUser(decoded));
    })
    .catch((err) => dispatch(receiveErrors(err.response?.data || err)));

export const logout = () => (dispatch) => {
  localStorage.removeItem('jwtToken');
  APIUtil.setAuthToken(false);
  dispatch(logoutUser());
};

export const fetchUser = () => (dispatch) =>
  APIUtil.fetchUser()
    .then((res) => dispatch(receiveCurrentUser(res.data ?? res)))
    .catch((err) => dispatch(receiveErrors(err.response?.data || err)));
